<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Add payment
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.pt-6.pb-3
      .text-md.font-semibold.neutral500--text Fill the information below
      v-form(ref="form")
        div.text-sm.font-semibold.neutral500--text.mt-4 Payment name
        v-text-field.text-sm.round-xl.mt-2(v-model="payment.name" placeholder="Enter payment name" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
        //- div.text-sm.font-semibold.neutral500--text.mt-4 Payment URL
        //- v-text-field.text-sm.round-xl.mt-2(v-model="payment.verification_link" placeholder="Enter payment URL" outlined dense height="48" hide-details="auto")
        div.text-sm.font-semibold.neutral500--text.mt-4 Price tier
        div.d-flex.justify-center.mt-16(v-if="isFetching")
          v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
        template(v-else)
          v-row.mt-2(v-if="priceTiers.length > 0" dense)
            v-col(v-for="pricetier in priceTiers" cols="12" :key="pricetier.id")
              div.d-flex
                div.mt-1
                  y-checkbox(v-model="pricetier.check")
                div.ml-1
                  .text-sm.font-medium.neutral700--text {{ pricetier.name }}
                  .text-sm.neutral700--text {{ pricetier.description }}
          div.empty-box.mt-6.pa-8(v-else align="center")
            v-avatar(color="neutral300" size="54")
              v-icon(color="neutral500" size="30") mdi-tag-outline
            div.text-center.text-md.font-semibold.neutral700--text.mt-6 You don’t have any pricing tier yet
            div.text-center.text-sm.font-normal.neutral500--text.mt-1 Set your pricing tier now
            y-button.mt-6(label="Set your pricing tier" size="sm" color="neutral700" text-color="neutral100" icon-color="neutral100" icon-size="20" append-icon="mdi-arrow-top-right" @click="goToPriceTiers")

    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Confirm" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false
    },
    parentPayment: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    isFetching: false,
    isLoading: false,
    pageSize: -1,
    payment: {},
    priceTiers: [],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
      has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
      not_empty_select: [v => !!v || 'This field is required']
    },
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.fetchPriceTiers()
    if (this.parentPayment) {
      this.payment = {
        name: this.parentPayment.name,
        // verification_link: this.parentPayment.verification_link,
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPriceTiers () {
      this.isFetching = true
      const params = {
        company: this.company.id,
        status: 'active',
        page_size: this.pageSize
      }
      this.$axios.get('/product_pricetiers', { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            let data = resp.data.results
            data.forEach(o => {
              if (this.parentPayment && this.parentPayment.price_tiers.find(f => f.id === o.id)) {
                o.check = true
              } else {
                o.check = false
              }
            })
            this.priceTiers = data
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      if (this.parentPayment) {
        let data = {
          name: this.payment.name,
          // verification_link: this.payment.verification_link,
          price_tiers: this.priceTiers.filter(f => f.check).map(m => m.id)
        }
        this.$axios.patch(`/payment_methods/${this.parentPayment.id}`, data)
          .then(() => {
            this.$emit('reset')
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        let data = {
          company: this.company.id,
          channel: 'self-pay',
          name: this.payment.name,
          // verification_link: this.payment.verification_link,
          price_tiers: this.priceTiers.filter(f => f.check).map(m => m.id)
        }
        this.$axios.post(`/payment_methods`, data)
          .then(() => {
            this.$emit('reset')
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    closeDialog () {
      this.$emit('closed')
    },
    goToPriceTiers () {
      this.$router.push('/admin/clinic/settings/price-tier-settings')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
</style>